<template>
  <div class="flex flex-col gap-2 h-full">
    <template v-if="props.documents?.length > 0">
      <div
        v-for="document in props.documents"
        :key="document.id"
        class="flex items-center gap-4 w-full border rounded-xl p-3 bg-white border-gray-200"
      >
        <div class="p-1 rounded-full">
          <FileFive
            class="text-brand-600 w-8 h-8 p-1.5 rounded-full aspect-square"
          />
        </div>
        <div class="w-full flex flex-col">
          <span class="text-base font-medium flex text-gray-700">
            {{ document.title }}
          </span>
        </div>
        <div
          class="p-1 rounded-full cursor-pointer"
          @click="download(document)"
        >
          <DownloadIcon
            class="text-brand-600 w-8 h-8 p-1.5 rounded-full aspect-square"
          />
        </div>
      </div>
    </template>
    <NoResults
      v-else
      hide-button
      :title="t('admin.space_overview.documents.empty_title')"
      :description="t('admin.space_overview.documents.empty_description')"
    />
  </div>
</template>

<script setup>
import FileFive from "@/Tailwind/Icon/FileFive.vue";
import DownloadIcon from "@/Tailwind/Icon/DownloadIcon.vue";
import { useWebView } from "@/Tailwind/Mixins/useWebView";
import { mobileSatisfiesVersion } from "@/Tailwind/Helpers/version";
import { useI18n } from "vue-i18n";
import NoResults from "@/Tailwind/Components/ListView/NoResults.vue";

const props = defineProps({
  documents: Array,
});

const { t } = useI18n();
const { runningInWebView, openURL } = useWebView();
const download = (document) => {
  const url = document.file.urls.file;

  if (!runningInWebView()) {
    window.open(url, "_blank");
    return;
  }

  if (mobileSatisfiesVersion("2.2.0")) {
    openURL(url);
    return;
  }

  // Fallback for outdated mobile apps.
  window.open(url, "_blank");
};
</script>
